export default "__VITE_ASSET__Bgj2LnO3__"